/*
 *
 *  actions
 *
 */

import {
  LOAD_RECORDS_VALID_CACHE,
  LOAD_RECORDS_META_DATA,
  LOAD_RECORDS_META_DATA_SUCCESS,
  LOAD_RECORDS_META_DATA_ERROR,

  LOAD_LEVEL_ONE,
  LOAD_LEVEL_ONE_SUCCESS,
  LOAD_LEVEL_ONE_ERROR,


  ADD_TEAM_ASSIGN,
  ADD_TEAM_ASSIGN_SUCCESS,
  ADD_TEAM_ASSIGN_ERROR,

  ADD_PRODUCT_ASSIGN,
  ADD_PRODUCT_ASSIGN_SUCCESS,
  ADD_PRODUCT_ASSIGN_ERROR,

  LOAD_PRODUCTION_ASSIGN_HISTORY,
  LOAD_PRODUCTION_ASSIGN_HISTORY_SUCCESS,
  LOAD_PRODUCTION_ASSIGN_HISTORY_ERROR,

  ADD_CLEARANCE,
  ADD_CLEARANCE_SUCCESS,
  ADD_CLEARANCE_ERROR,

  CRM_RESET,

  UPDATE_APPROVAL,
  UPDATE_APPROVAL_SUCCESS,
  UPDATE_APPROVAL_ERROR

} from "./constants"

export function loadRecordsCacheHit() {
  return {
    type: LOAD_RECORDS_VALID_CACHE,
  }
}

export function loadRecordsMetaData() {
  return {
    type: LOAD_RECORDS_META_DATA,
  }
}

/**
 *
 * @param {object} recordsMetaData
 * @returns
 */
export function loadRecordsMetaDataSuccess(recordsMetaData) {
  return {
    type: LOAD_RECORDS_META_DATA_SUCCESS,
    recordsMetaData,
  }
}

/**
 *
 * @param {string} error
 * @returns
 */
export function loadRecordsMetaDataError(error) {
  return {
    type: LOAD_RECORDS_META_DATA_ERROR,
    error,
  }
}

//LevelOne
//LEVEL_ONE
export function loadLevelOne(searchvalue) {
  return {
    type: LOAD_LEVEL_ONE,
    searchvalue,
  }
}
export function loadLevelOneSuccess(levelOne_details) {
  return {
    type: LOAD_LEVEL_ONE_SUCCESS,
    levelOne_details,
  }
}
export function loadLevelOneError(error) {
  return {
    type: LOAD_LEVEL_ONE_ERROR,
    error,
  }
}

export function addTeamAssign(team_details) {
  return {
    type: ADD_TEAM_ASSIGN,
    team_details,
  }
}

export function addTeamAssignSuccess(team_details) {
  return {
    type: ADD_TEAM_ASSIGN_SUCCESS,
    team_details

  }
}


export function addTeamAssignError(error) {
  return {
    type: ADD_TEAM_ASSIGN_ERROR,
    error,
  }
}

export function addProductAssign(product_details) {
  return {
    type: ADD_PRODUCT_ASSIGN,
    product_details,
  }
}

export function addProductAssignSuccess(product_details) {
  return {
    type: ADD_PRODUCT_ASSIGN_SUCCESS,
    product_details

  }
}


export function addProductAssignError(error) {
  return {
    type: ADD_PRODUCT_ASSIGN_ERROR,
    error,
  }
}

//PRODUCTION ASSIGN HISTORY
export function loadProductionAssignHistory(historyPayload) {
  return {
    type: LOAD_PRODUCTION_ASSIGN_HISTORY,
    historyPayload,
  }
}
export function loadProductionAssignHistorySuccess(history_details) {
  return {
    type: LOAD_PRODUCTION_ASSIGN_HISTORY_SUCCESS,
    history_details,
  }
}
export function loadProductionAssignHistoryError(error) {
  return {
    type: LOAD_PRODUCTION_ASSIGN_HISTORY_ERROR,
    error,
  }
}
export function crmReset() {
  return {
    type:CRM_RESET,
  }
}

//add clearance

export function addClearance(applyClearance) {
  return {
    type: ADD_CLEARANCE,
    applyClearance,
  }
}
export function addClearanceSuccess(crmSuccess) {
  return {
    type: ADD_CLEARANCE_SUCCESS,
    crmSuccess,
  }
}
export function addClearanceError(crmError) {
  return {
    TYPE: ADD_CLEARANCE_ERROR,
    crmError,
  }
}
//UPDATE_APPROVAL

export function updateApproval(approve_data) {
  return {
    type: UPDATE_APPROVAL,
    approve_data,
  }
}
export function updateApprovalSuccess(dataDetails) {
  return {
    type: UPDATE_APPROVAL_SUCCESS,
    dataDetails,
  }
}
export function updateApprovalError(error) {
  return {
    TYPE: UPDATE_APPROVAL_ERROR,
    error,
  }
}
const actions = {
  loadRecordsCacheHit,
  loadRecordsMetaData,
  loadRecordsMetaDataSuccess,
  loadRecordsMetaDataError,


  loadLevelOne,
  loadLevelOneSuccess,
  loadLevelOneError,

  addTeamAssign,
  addTeamAssignSuccess,
  addTeamAssignError,

  addProductAssign,
  addProductAssignSuccess,
  addProductAssignError,

  loadProductionAssignHistory,
  loadProductionAssignHistorySuccess,
  loadProductionAssignHistoryError,

  addClearance,
  addClearanceSuccess,
  addClearanceError,
  crmReset,

  updateApprovalSuccess,
  updateApproval,
  updateApprovalError
}

export default actions
